import { Container, Flex, Image, Text } from "@chakra-ui/react";
import { Button, Footer, Tabs, Visible } from "components";
import { PreviousTrips } from "./PreviousTrips";
import { UpcomingTrips } from "./UpcomingTrips";

  
const Trips = () => {
    const trips = ['0'];

    const tabList = [{
        id: 1,
        title: 'Upcoming',
        content:<UpcomingTrips trips={trips} />
      },
      {
        id: 2,
        title: 'Previous',
        content: <PreviousTrips trips={trips} />
      }];
    return (
        <>
        <Container>
            <Visible when={trips.length === 0}>
                <Flex flexDirection='column' align='center'>
                    <Image src='../../no_trips.png' />
                    <Text fontWeight={600} fontSize='20px'> No upcoming Trips</Text>
                    <Text marginBottom={10} fontWeight={400} fontSize='18px'>Simply plan your Trips by clicking the following button</Text>
                    <Button label="Start Exploring" onClick={()=>{}} colorScheme='blue' />
                </Flex>
            </Visible>
           
        </Container>
        <Visible when={trips.length !== 0}>
            <Container maxWidth='60%'>
                <Tabs width="200px" tabList={tabList}  orientation="vertical" />
            </Container>
        </Visible>
        <Footer />
        </>
    );
  };
  
  export { Trips };
  